import { render, staticRenderFns } from "./VisitCallVvrtc.vue?vue&type=template&id=fb9d4440&scoped=true&"
import script from "./VisitCallVvrtc.vue?vue&type=script&lang=js&"
export * from "./VisitCallVvrtc.vue?vue&type=script&lang=js&"
import style0 from "./VisitCallVvrtc.vue?vue&type=style&index=0&id=fb9d4440&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9d4440",
  null
  
)

export default component.exports